import { Badge, Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@chain-zen/ui'
import { format, parseISO } from 'date-fns'
import React from 'react'

import type { IPostOfferReturnType } from '../../../types/post'
import { currencyFormatter } from '../../../utils/common'

interface OfferDetailsMessageProps {
  emptyAtPreviousReceiverTime?: string
  location?: string
}

export const offerDetailsMessage = ({ emptyAtPreviousReceiverTime, location }: OfferDetailsMessageProps) => {
  let messageInput = ''

  if (emptyAtPreviousReceiverTime) {
    const date = format(parseISO(emptyAtPreviousReceiverTime), 'MMM dd')
    const time = format(parseISO(emptyAtPreviousReceiverTime), 'h:mm a')

    if (location) {
      messageInput = `Carrier will be empty in ${location} at ${time} (on ${date})`
    } else {
      messageInput = `Carrier will be empty at ${time} (on ${date})`
    }
  } else if (location) {
    messageInput = `Carrier will be empty in ${location}`
  }

  return messageInput
}

/**
 * OfferDetails displays the info about the offer in right nav on inbox page offers chat
 */
export const OfferDetails = ({ offer }: { offer: IPostOfferReturnType }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Offer details</CardTitle>
        <CardDescription>
          <div className="flex items-center justify-between gap-2">
            <span>Offer amount</span>
            <Badge>${currencyFormatter(offer.amount.value.toString(), 2)}</Badge>
          </div>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-2">
          <span className="text-sm">MC #</span>
          <span className="text-sm">{offer.mcNumber ? offer.mcNumber : '--'}</span>
        </div>
      </CardContent>
      <CardFooter>
        <div className="text-muted-foreground text-xs">
          {offerDetailsMessage({
            emptyAtPreviousReceiverTime: offer.emptyAtPreviousReceiverTime,
            location: offer.location
          })}
        </div>
      </CardFooter>
    </Card>
  )
}
